import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface GrowthChartRawPoint {
  title_id: number
  date: string
  value: number
}

export interface GrowthChartDate {
  year: string
  month: string
  day: string
}

export interface GrowthChartDateRange {
  start: GrowthChartDate
  end: GrowthChartDate
  current: GrowthChartDate
}

export interface GrowthChartTitle {
  id: number
  name: string
  color: string
}

export interface ChartPoint {
  value: number
  date: string
}

export interface ChartResponse {
  data: ChartPoint[]
  meta: { message: string; errors: string[] }
}

export interface ExportReportResponse {
  url: string
  status: number
}

export function getGrowthChartDataAction(
  fromDate: string,
  toDate: string,
  type: 'years' | 'months' | 'days'
): Promise<ApiResponse<GrowthChartRawPoint[]>> {
  return api.get(`/exports/growth/chart`, {
    params: {
      fromDate,
      toDate,
      type,
    },
  })
}

export function getGrowthChartDateRangeAction(): Promise<ApiResponse<GrowthChartDateRange[]>> {
  return api.get(`/exports/growth/date`)
}

export function getGrowthChartTitlesAction(): Promise<ApiResponse<GrowthChartTitle[]>> {
  return api.get(`/exports/growth/titles`)
}

export function updateGrowthChartAction(): Promise<ApiResponse<unknown>> {
  return api.post(`/exports/growth/update`)
}

export function getRegisteredRequisitionsAction(
  fromDate?: string,
  toDate?: string
): Promise<ApiResponse<ChartResponse>> {
  return api.get(`/charts/registered-requisitions`, {
    params: {
      from_date: fromDate,
      till_date: toDate,
    },
  })
}

export function getSuccessfulTransactionsAction(
  fromDate?: string,
  toDate?: string
): Promise<ApiResponse<ChartResponse>> {
  return api.get(`/charts/successful-transactions`, {
    params: {
      from_date: fromDate,
      till_date: toDate,
    },
  })
}

export function getTotalCommissionIncomeAction(
  fromDate?: string,
  toDate?: string
): Promise<ApiResponse<ChartResponse>> {
  return api.get(`/charts/total-commission-income-amount`, {
    params: {
      from_date: fromDate,
      till_date: toDate,
    },
  })
}

export function getTotalCurrencyIncomeAction(fromDate?: string, toDate?: string): Promise<ApiResponse<ChartResponse>> {
  return api.get(`/charts/total-currency-income-amount`, {
    params: {
      from_date: fromDate,
      till_date: toDate,
    },
  })
}

export function getTotalRegisteredRequisitionsAmountAction(
  fromDate?: string,
  toDate?: string
): Promise<ApiResponse<ChartResponse>> {
  return api.get(`/charts/total-registered-requisitions-amount`, {
    params: {
      from_date: fromDate,
      till_date: toDate,
    },
  })
}

export function getTotalSuccessfulTransactionsAmountAction(
  fromDate?: string,
  toDate?: string
): Promise<ApiResponse<ChartResponse>> {
  return api.get(`/charts/total-successful-transactions-amount`, {
    params: {
      from_date: fromDate,
      till_date: toDate,
    },
  })
}

export function getTotalRegisteredRequisitionsCurrencyAmountAction(
  fromDate?: string,
  toDate?: string
): Promise<ApiResponse<ChartResponse>> {
  return api.get(`/charts/total-registered-requisitions-currency-amount`, {
    params: {
      from_date: fromDate,
      till_date: toDate,
    },
  })
}

export function getTotalSuccessfulTransactionsCurrencyAmountAction(
  fromDate?: string,
  toDate?: string
): Promise<ApiResponse<ChartResponse>> {
  return api.get(`/charts/total-successful-transactions-currency-amount`, {
    params: {
      from_date: fromDate,
      till_date: toDate,
    },
  })
}

export function exportReportAction(
  type: string,
  fromDate: string,
  tillDate: string
): Promise<
  ApiResponse<
    ExportReportResponse & {
      message: string
      status: number
    }
  >
> {
  return api.get(`/exports/${type}`, {
    params: {
      from_date: fromDate,
      till_date: tillDate,
    },
  })
}
